import { Link } from 'react-router-dom';
import { BlogCta } from '@/components/BlogCta';
import { formatArticleDate, listArticles } from '@/lib/blog';
import { pathWithLang } from '@/lib/site';
import { useLang, useT } from '@/lib/useLang';

/**
 * Tous les articles, quelle que soit la langue de l'interface.
 *
 * DispatchSEO écrit en français alors que le site s'ouvre en anglais : filtrer
 * par langue cachait chaque nouvel article à qui arrivait sur `/blog`. Chaque
 * carte porte donc sa langue, et son lien ouvre l'article dans SA langue (son
 * URL canonique) plutôt que dans celle de la liste.
 */
export function BlogIndex() {
  const t = useT();
  const lang = useLang();
  const articles = listArticles();

  return (
    <>
      <section className="nz-page">
        <div className="nz-eyebrow">{t.navBlog}</div>
        <h1 className="nz-page__title">{t.blogTitle}</h1>
        <p className="nz-lead">{t.blogIntro}</p>

        {articles.length === 0 ? (
          <p className="nz-page__empty">{t.blogEmpty}</p>
        ) : (
          <div className="nz-articles">
            {articles.map((article) => (
              <article className={article.cover ? 'nz-card nz-card--cover' : 'nz-card'} key={article.slug}>
                {article.cover && (
                  <Link className="nz-card__cover" to={pathWithLang(`/blog/${article.slug}`, article.lang)} tabIndex={-1} aria-hidden="true">
                    <img src={article.cover} alt="" width={1600} height={900} loading="lazy" />
                  </Link>
                )}
                <div className="nz-card__meta">
                  <span className="nz-card__lang">{article.lang.toUpperCase()}</span>
                  <time dateTime={article.date}>{formatArticleDate(article.date, lang)}</time>
                  <span aria-hidden="true">·</span>
                  <span>
                    {article.readingMinutes} {t.blogMinutes}
                  </span>
                </div>
                <h2 className="nz-card__title" lang={article.lang}>
                  <Link to={pathWithLang(`/blog/${article.slug}`, article.lang)} hrefLang={article.lang}>
                    {article.title}
                  </Link>
                </h2>
                <p className="nz-card__desc" lang={article.lang}>
                  {article.description}
                </p>
                <span className="nz-card__more" aria-hidden="true">
                  {t.blogReadMore} →
                </span>
              </article>
            ))}
          </div>
        )}
      </section>

      <BlogCta />
    </>
  );
}
